module.exports = __webpack_public_path__ + "static/media/grab_alc_leo_320_bottle24.02ce3ab0.jpg";